import * as http from 'utils/http';
import config from 'config';

const getDriver = async (driverId) => {
  return await http.get(`${config.API_URL}mercury/drivers/${driverId}/`);
};

const getItinerary = async (itineraryId) => {
  return await http.get(`${config.API_URL}itineraries/${itineraryId}/`);
};

const getPositions = async ({ itineraryId, pickupTimeFrom, center, northEast, vehicleTypes }) => {
  const params = {
    pickup_time_from: pickupTimeFrom,
    center_map: center,
    north_east_map: northEast,
    vehicle_types: vehicleTypes,
  };

  return await http.get(
    `${config.API_URL}assignment/itineraries/${itineraryId}/drivers-positions/?${Object.keys(params)
      .map((key) => (params[key] ? `${key}=${params[key]}` : ''))
      .filter((v) => !!v)
      .join('&')}`
  );
};

const getJourneysByDriver = async (driverId, date = '2019-11-08') => {
  return await http.get(
    `${config.API_URL}assignment/journeys/by_driver/?drivers=${driverId}&pickup_time_from=${date}`
  );
};

export { getDriver, getItinerary, getPositions, getJourneysByDriver };
